import { render, staticRenderFns } from "./KanbanBoardFilters.vue?vue&type=template&id=1ffc16d4&scoped=true&"
import script from "./KanbanBoardFilters.vue?vue&type=script&lang=js&"
export * from "./KanbanBoardFilters.vue?vue&type=script&lang=js&"
import style0 from "./KanbanBoardFilters.vue?vue&type=style&index=0&id=1ffc16d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc16d4",
  null
  
)

export default component.exports